export default __webpack_public_path__ + "static/media/developer-tools.6ba30dcc.svg";